export default {
  setList: (state, list) => {
    state.list = list;
  },
};
